import {
  ThemeProvider as RescueTabletThemeProvider,
  type ThemeProviderProps,
} from "@rescuetablet/theme";
import { type ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { useSetting } from "./data/settings";

const args = [
  {
    components: {
      MuiCardActions: {
        styleOverrides: { root: { justifyContent: "flex-end" } },
      },
    },
  },
];

export default function ThemeProvider({ children }: { children: ReactNode }) {
  return (
    <RescueTabletThemeProvider {...useUserTheme()}>
      {children}
    </RescueTabletThemeProvider>
  );
}

function useUserTheme(): ThemeProviderProps {
  const fontSize = useSetting("fontSize");
  const colorScheme = useSetting("colorScheme");
  const {
    i18n: { language },
  } = useTranslation();

  return {
    fontSize,
    colorScheme,
    language,
    args,
  };
}
